/* eslint-disable max-len */
import { capitalCase } from 'change-case';
import { Component, ComponentType } from '../../../../concepts/objects';
import { ExportDimension, ExportDimensionParams, ExportDimensionType, ExportDimensionUI, ExportValue } from '../ExportDimension';

export const DefineSimpleDimension = <T extends Component>(type: ComponentType<T>, label: string, description: string, getter: (obj: T) => any) =>
    DefineSimpleDimensionWithUI(type, label, description, null, getter);

export const DefineSimpleDimensionWithUI = <T extends Component>(type: ComponentType<T>, label: string, description: string, ui: ExportDimensionUI, getter: (obj: T, params: ExportDimensionParams) => any) => {
    const desc = Component.describe(type);
    const id = `${desc?.name ?? 'Component'}:${capitalCase(label)}`;
    return ExportDimensionType({
        id,
        label,
        description,
        ui,
        createInstance(params) {
            return ExportDimension({
                id,
                type: this,
                params: params ?? {},
                label,
                read(rows) {
                    const head = [ExportValue(this.id, this.label)];
                    const body = rows.map(c => ExportValue([c.id, this.id], getter(c as any, this.params)));
                    return [head.concat(body)];
                }
            });
        },
    });
};

export type ExportDimensionFactory = (type: ExportDimensionType, params: ExportDimensionParams) => ExportDimension;

export const DefineDimension = (id: string, label: string, description: string, factory: ExportDimensionFactory) =>
    DefineDimensionWithUI(id, label, description, null, factory);

export const DefineDimensionWithUI = (id: string, label: string, description: string, ui: ExportDimensionUI, factory: ExportDimensionFactory) => {
    const type = { id, label, description, ui } as Partial<ExportDimensionType>;
    type.createInstance = (params) => factory(type as any, params);
    return type as ExportDimensionType;
};
